// @flow

import { OPERATION_TREE, OPERATION_BRANCH } from 'fc-model-sampling-points'

import traverse from 'fc-utils/traverse'

export default traverse([OPERATION_TREE, OPERATION_BRANCH])
